<template>
  <b-row id="Footer">
    <b-col cols="12">
      <b-container>
        <b-row class="rows-footer">
          <b-col sm="8" class="copyright">Copyright 2021 Bizpro</b-col>
          <b-col sm="4" class="contact">
            <a href="mailto:info@bizpro.com.gt">info@bizpro.com.gt</a>
            &nbsp;
            +502 2309-7963
          </b-col>
        </b-row>
      </b-container>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped lang="scss">
@import "../../../scss/custom";

#Footer {
  background-color: $blue;
  color: $gray-500;
  text-align: center;
  padding: 5px 0;

  a {
    color: $white;
  }
}

@media (max-width: 575px) {
  .rows-footer {
    .copyright {
      order: 2;
    }

    .contact {
      order: 1;
    }
  }
}
</style>
